import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import slugify from "slugify";

//constants
import { urlAssets } from '../../Constants';

//types
import { DataByDistrict } from '../../types/types';

type CandidateHeadingDataProps = {
    partyCandidateProposals: DataByDistrict, 
}

const CandidateHeadingData = ({ partyCandidateProposals }: CandidateHeadingDataProps) => {
    
    return (
        <section className="col-6 px-1 px-md-2">
            <section className="p-3 rounded bg-grey-comparing-heading">
                <article className="d-flex justify-content-start align-items-center pb-2 pb-md-3 border-bottom">
                    <LazyLoadImage                                        
                        alt={partyCandidateProposals.Candidato}
                        className="img-category-candidate"
                        effect="blur"
                        src={`${urlAssets}img/candidatos/${slugify((partyCandidateProposals.Candidato).toLowerCase())}.png`}
                    />
                    <h2 className="mb-0 mx-2 category-candidate-name">{partyCandidateProposals.Candidato}</h2>
                </article>
                <article className="d-flex justify-content-start align-items-center pt-2 pt-md-3 cont-party-logo-name">
                    <LazyLoadImage                                        
                        alt={partyCandidateProposals.Partido}
                        className="py-0 party-logo"
                        effect="blur"
                        src={`${urlAssets}img/partidos/${slugify((partyCandidateProposals.Partido).toLowerCase())}.png`}
                    />
                    <h5 className="mb-0 ms-2 category-party-name">{partyCandidateProposals.Partido}</h5>
                </article>
            </section>
        </section>
    )
}

export default CandidateHeadingData;